import { ApiCall } from '../ApiClient';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export const externalEndpoints = {

    // systems: {

    //     // info: (externalSystemId:string) => get<any>({

    //     // }),

    //     list: () => get<any>({
    //         path: '/external.systems.list',
    //     })
    // },

    // recordSets: {

    //     create: (body: ExternalRecordSetInput) => post<any>({
    //         path: '/external.recordSets.create',
    //         body,
    //     }),

    //     list: (externalSystemId: string) => get<any>({
    //         path: '/external.recordSets.list',
    //         query: { externalSystemId },
    //     }),
    // }
};
